import BasicRepository from "./basicRepository";
import Client from "../client";

class SubscriptionRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("Subscriptions", client);
    }
}

export default SubscriptionRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/subscriptionRepository.ts